import React from "react";
// hook
import { useStyles } from "../hooks/table.useStyles";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// UI
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
// method
import { setSortData } from "../methods/common.methods";
// components
import { TabKey } from "../MasterMaintenance.constants";

export const MasterMaintenanceCustomerMasterTbody = (props: any) => {
  const { pageInfo, selected, order, orderBy } = props;
  const classes = useStyles();
  const { t } = useLocale({
    defaultPath: "modules.components.MasterMaintenance.customerMaster",
  });
  const { com } = useLocale({ defaultPath: "common.constants" });

  return (
    <TableBody>
      {setSortData(props.data, order, orderBy, TabKey.customerMaster)
        .slice(
          pageInfo.page * pageInfo.rowsPerPage,
          pageInfo.page * pageInfo.rowsPerPage + pageInfo.rowsPerPage
        )
        .map((row: any, index: number) => {
          return (
            <TableRow className={classes.tbody} hover tabIndex={-1} key={index}>
              <TableCell className={classes.nowrap}>{row.no}</TableCell>
              <TableCell className={classes.nowrap}>{row.name}</TableCell>
              <TableCell className={classes.nowrap}>{row.mail_r}</TableCell>
              <TableCell className={classes.contents}>{row.mem}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.sms ? "Y" : "N"}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.mail_n ? "Y" : "N"}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.asc ? "Y" : "N"}
              </TableCell>
              <TableCell className={classes.nowrap}>{row.pic_sort}</TableCell>
              <TableCell className={classes.nowrap}>{row.app_sort}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.credit_note_interval_message}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() => props.handleEdit(row, TabKey.customerMaster)}
                >
                  {t("edit")}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};
